import { useTransactionActions } from '@/client/hooks/use-transaction-actions';
import { topmostOwner, useTradeOverlayStore } from '@/client/store/trade-overlay-store';
import { useTranslation } from 'react-i18next';

const linkClass = 'text-xs text-foreground/50 hover:text-foreground/70 underline transition-colors';

const Actions = ({ owner }: { owner: string }) => {
  const { t } = useTranslation();
  const { record, canRecheck, canAcknowledgeCancel, recheck, acknowledgeCancel } = useTransactionActions();
  // Only the topmost overlay, and only when it hosts the record's market, shows
  // the actions; otherwise the global toast stays visible and keeps them (I1).
  const owns = useTradeOverlayStore(state => !!record && topmostOwner(state.slots, record.marketAddress) === owner);
  if (!owns || (!canRecheck && !canAcknowledgeCancel)) return null;
  return (
    <div className="mt-3 flex justify-center gap-4">
      {canRecheck && (
        <button type="button" className={linkClass} onClick={recheck}>
          {t('transaction-recheck')}
        </button>
      )}
      {canAcknowledgeCancel && (
        <button type="button" className={linkClass} onClick={acknowledgeCancel}>
          {t('transaction-wallet-cancelled')}
        </button>
      )}
    </div>
  );
};

/**
 * The global toast's recovery actions (recheck a restored hash, acknowledge a
 * wallet cancellation), rendered by a mobile trade overlay (DrawerSheet /
 * DrawerDiaLog) on top of every other overlay, for records of the market it
 * hosts, while that toast is hidden for them. Rendered by the overlay itself,
 * not the trade form, so the actions stay reachable while the panel is still
 * loading. Desktop never mounts this.
 */
export const PanelTransactionActions = ({ owner }: { owner: string }) => {
  // No overlay slot means the toast is visible; skip the wallet/store hooks entirely.
  const anyOverlay = useTradeOverlayStore(state => state.slots.length > 0);
  return anyOverlay ? <Actions owner={owner} /> : null;
};
